import React from 'react';

export const UniqueMemberServedIcon = ({ width, height, className, fill = '#722ED1' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 44 62" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path fill="none" d="M32.0071 7.82489C33.3931 9.87496 34.2015 12.3293 34.2015 14.9857C34.1727 21.9155 28.7154 27.546 21.8434 27.777C21.5546 27.7481 21.2081 27.7481 20.8905 27.777C17.5763 27.6645 14.4361 26.2664 12.1347 23.8789C9.83343 21.4913 8.55177 18.3018 8.56118 14.9857C8.56118 7.91151 14.2783 2.16553 21.3814 2.16553M7.40621 38.4316C0.418633 43.1093 0.418633 50.7321 7.40621 55.3808C15.3466 60.6937 28.3689 60.6937 36.3094 55.3808C43.297 50.7032 43.297 43.0804 36.3094 38.4316C28.3978 33.1476 15.3755 33.1476 7.40621 38.4316Z" stroke={fill} strokeWidth="4.33114" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
   
  );
};
